import ApiClient from './ApiClient';

class BotFlowModelsAPI extends ApiClient {
  constructor() {
    super('bot_flow_models', { accountScoped: true });
  }
}

export default new BotFlowModelsAPI();
